// extracted by mini-css-extract-plugin
export var grid = "_12-0";
export var span1 = "_12-2";
export var span10 = "_12-b";
export var span10L = "_12-z";
export var span10M = "_12-n";
export var span10Xl = "_12-1b";
export var span11 = "_12-c";
export var span11L = "_12-10";
export var span11M = "_12-o";
export var span11Xl = "_12-1c";
export var span12 = "_12-d";
export var span12L = "_12-11";
export var span12M = "_12-p";
export var span12Xl = "_12-1d";
export var span1L = "_12-q";
export var span1M = "_12-e";
export var span1Xl = "_12-12";
export var span2 = "_12-3";
export var span2L = "_12-r";
export var span2M = "_12-f";
export var span2Xl = "_12-13";
export var span3 = "_12-4";
export var span3L = "_12-s";
export var span3M = "_12-g";
export var span3Xl = "_12-14";
export var span4 = "_12-5";
export var span4L = "_12-t";
export var span4M = "_12-h";
export var span4Xl = "_12-15";
export var span5 = "_12-6";
export var span5L = "_12-u";
export var span5M = "_12-i";
export var span5Xl = "_12-16";
export var span6 = "_12-7";
export var span6L = "_12-v";
export var span6M = "_12-j";
export var span6Xl = "_12-17";
export var span7 = "_12-8";
export var span7L = "_12-w";
export var span7M = "_12-k";
export var span7Xl = "_12-18";
export var span8 = "_12-9";
export var span8L = "_12-x";
export var span8M = "_12-l";
export var span8Xl = "_12-19";
export var span9 = "_12-a";
export var span9L = "_12-y";
export var span9M = "_12-m";
export var span9Xl = "_12-1a";
export var stretch = "_12-1";